import { render, staticRenderFns } from "./FixedChattingPanel.vue?vue&type=template&id=65d55c48&scoped=true"
import script from "./FixedChattingPanel.vue?vue&type=script&lang=js"
export * from "./FixedChattingPanel.vue?vue&type=script&lang=js"
import style0 from "./FixedChattingPanel.vue?vue&type=style&index=0&id=65d55c48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d55c48",
  null
  
)

export default component.exports